module.exports = __webpack_public_path__ + "img/Daniele Maffeism.e0e221ae.jpg";